import { Controller } from "@hotwired/stimulus";

// Lazy "Market snapshot" tiles for the Account dashboard (SUR handoff — the
// honest subset of the deferred Market Stats design). The section starts hidden;
// on connect we fetch /account/market_snapshot (curated tiles for the agent's
// first coverage area) and reveal the block only when real tiles come back. The
// ez work happens server-side and OFF the no-store /account render path, so a
// slow/empty/failed fetch simply leaves the section hidden — never a spinner or
// an empty card. No inline script; markup lives in connect/account/show.
export default class extends Controller {
  static targets = ["section", "heading", "tiles"];
  static values = { url: { type: String, default: "/account/market_snapshot" } };

  connect() {
    this.load();
  }

  async load() {
    try {
      const res = await fetch(this.urlValue, {
        headers: { Accept: "application/json" },
        credentials: "same-origin",
      });
      if (!res.ok) return;
      const data = await res.json();
      const tiles = Array.isArray(data.tiles) ? data.tiles : [];
      if (!tiles.length) return; // degrade-safe: nothing real → stay hidden

      this.render(data.area, tiles);
    } catch {
      /* keep the section hidden on any failure */
    }
  }

  render(area, tiles) {
    if (this.hasHeadingTarget && area) {
      this.headingTarget.textContent = `Market snapshot — ${area}`;
    }
    if (this.hasTilesTarget) {
      this.tilesTarget.replaceChildren(...tiles.map((t) => this.tile(t)));
    }
    if (this.hasSectionTarget) this.sectionTarget.hidden = false;
  }

  // One stat tile: <div><div class="ssc-statlist-v">value</div><div
  // class="ssc-statlist-k">label</div></div>. Built with textContent (values are
  // agent-area market figures, but treat as untrusted — never innerHTML).
  tile(t) {
    const wrap = document.createElement("div");
    const value = document.createElement("div");
    value.className = "ssc-statlist-v";
    value.textContent = String(t.value ?? "");
    const label = document.createElement("div");
    label.className = "ssc-statlist-k";
    label.textContent = String(t.label ?? "");
    wrap.append(value, label);
    return wrap;
  }
}
